import { render } from "./totaldue.vue?vue&type=template&id=b53beb18"
import script from "./totaldue.vue?vue&type=script&lang=js"
export * from "./totaldue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__